module.exports = __webpack_public_path__ + "img/Norterra_Banner1.64448e99.png";